const bill = {
    getlist: '/Cafebazar/getlist',
    import: '/Cafebazar/import',
    exportExcel:'Cafebazar/excel',
    zarinPalgetlist: '/Zarinpal/getlist',
    zarinPalimport: '/Zarinpal/import',
    zarinPalexportExcel:'Zarinpal/excel',
  // bank saman
  bankSamanGetlist: '/saman/getlist',
  bankSamanImport: '/saman/import',
  bankSamanExportExcel:'saman/excel',

}
export default bill
